import { useOnline } from '@/hooks/useOnline';
import { WifiOff } from 'lucide-react';

export function OfflineBanner() {
    const online = useOnline();
    if (online) return null;
    return (
        <div
            role="status"
            aria-live="polite"
            className="sticky top-0 z-[50] flex items-center justify-center gap-2 bg-amber-500/20 border-b border-amber-500/40 text-amber-300 py-2 text-xs font-medium"
            style={{ paddingTop: 'env(safe-area-inset-top)' }}
        >
            <WifiOff className="w-3.5 h-3.5" />
            Sei offline — alcune funzioni non disponibili
        </div>
    );
}
